import { db } from "./db.js";
import { getMemberCaching, getCachedMemberRole } from "./teams.js";

// Docketing tasks for foreign trademark matters —
// firms/{firmId}/additions/tm-foreign/dockets. Every entry is manual (foreign
// marks have no auto-docketing); serialNumber holds the parent tm-foreign
// doc id so the docketing store can join tasks to matters across both
// collections.

function collection(firmId) {
  return db.collection(`firms/${firmId}/additions/tm-foreign/dockets`);
}

// ==================== CREATE ====================

function addForeignDocketTask(firmId, data) {
  const ref = collection(firmId).doc();
  data.id = ref.id;
  return ref.set({ source: "manual", ...data })
    .catch((error) => { console.log("Error in addForeignDocketTask " + error); });
}

// ==================== READ ====================

// Role-aware stream (mirrors streamDocketingOfUser): admins/managers stream
// all tasks; members and clients stream only tasks whose assigned[] contains
// their uid. Resolves to the unsubscribe function.
async function streamForeignDocketingOfUser(firmId, userId, onSnap) {
  const collectionRef = collection(firmId);
  const queryFor = (role) =>
    role === "admin" || role === "manager"
      ? collectionRef.orderBy("deadline")
      : collectionRef.where("assigned", "array-contains", userId).orderBy("deadline");
  const onError = (error) => { console.log(error); };

  const cachedRole = getCachedMemberRole(firmId, userId);
  if (cachedRole) {
    let unsubscribe = queryFor(cachedRole).onSnapshot(onSnap, onError);
    getMemberCaching(firmId, userId).then((member) => {
      const freshRole = (member && member.role) || "member";
      if (freshRole !== cachedRole) {
        unsubscribe();
        unsubscribe = queryFor(freshRole).onSnapshot(onSnap, onError);
      }
    });
    return () => unsubscribe();
  }

  const member = await getMemberCaching(firmId, userId);
  return queryFor((member && member.role) || "member").onSnapshot(onSnap, onError);
}

// Tasks for one foreign matter, deadline-ordered (detail page tab)
async function getForeignDocketTasksByTrademarkId(firmId, tmId) {
  const snapshot = await collection(firmId)
    .where("serialNumber", "==", tmId)
    .orderBy("deadline")
    .get();
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}

// ==================== UPDATE ====================

function updateForeignDocketTask(firmId, taskId, data, transaction = null) {
  const ref = collection(firmId).doc(taskId);
  if (transaction) {
    transaction.update(ref, data);
  } else {
    return ref.update(data);
  }
}

export {
  addForeignDocketTask,
  streamForeignDocketingOfUser,
  getForeignDocketTasksByTrademarkId,
  updateForeignDocketTask,
};
